/**
 * The `between` filter item's value shape: [start, end] as YYYY-MM-DD strings —
 * the native date input's format, which is also what the results endpoint
 * compares (`field:between(start,end)` on the wire). Halves are '' while
 * unset; the shared serializer drops the item until both are filled.
 */
export type DateBetweenValue = [string, string];

export const normalizeDateBetweenValue = (value: unknown): DateBetweenValue => {
  if (!Array.isArray(value)) return ['', ''];
  return [
    typeof value[0] === 'string' ? value[0] : '',
    typeof value[1] === 'string' ? value[1] : '',
  ];
};

/** True when both halves are set but the range is inverted (start after end). */
export const isInvertedDateRange = (value: unknown): boolean => {
  const [start, end] = normalizeDateBetweenValue(value);
  // ISO YYYY-MM-DD strings — lexicographic comparison IS chronological.
  return Boolean(start) && Boolean(end) && start > end;
};
